/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Row_NoneInputs */

const th_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีอีเมล เข้าสู่ระบบด้วยรหัสแล้วระบบจะบันทึกให้`)
};

const en_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No address yet — sign in with a code and it is registered for you.`)
};

const ja_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスはまだありません。コードでログインすると登録されます。`)
};

const zh_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚无邮箱地址——用验证码登录后就会为你记录下来。`)
};

const es_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay dirección: inicia sesión con un código y se registrará por ti.`)
};

const pt_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum endereço ainda — entre com um código e ele é registrado para você.`)
};

const id_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada alamat — masuk dengan kode dan alamatnya akan tercatat untuk Anda.`)
};

const fr_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore d’adresse — connectez-vous avec un code et elle sera enregistrée pour vous.`)
};

const tl_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang address — mag-sign in gamit ang code at maitatala ito para sa iyo.`)
};

const vi_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có địa chỉ — đăng nhập bằng mã và nó sẽ được ghi lại cho bạn.`)
};

const ko_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 주소가 없습니다 — 코드로 로그인하면 기록됩니다.`)
};

const de_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Adresse — melde dich mit einem Code an, dann wird sie für dich hinterlegt.`)
};

const ru_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреса пока нет — войдите по коду, и он сохранится за вами.`)
};

const tr_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz adres yok — kodla giriş yapın, sizin için kaydedilsin.`)
};

const it_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun indirizzo: accedi con un codice e verrà registrato per te.`)
};

const pl_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze adresu — zaloguj się kodem, a zostanie zapisany.`)
};

const uk_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреси ще немає — увійдіть за кодом, і її буде збережено для вас.`)
};

const hi_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई पता नहीं — कोड से साइन इन करें और यह आपके लिए दर्ज हो जाएगा।`)
};

const ar_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد عنوان بعد — سجّل الدخول برمز وسيُحفظ لك.`)
};

const ms_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada alamat — log masuk dengan kod dan ia akan direkodkan untuk anda.`)
};

const bn_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও ঠিকানা নেই — কোড দিয়ে সাইন ইন করুন, তখন এটি সংরক্ষিত হবে।`)
};

const zh_tw2_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無位址——用驗證碼登入後就會為你記錄下來。`)
};

const zh_hk2_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無位址——用驗證碼登入後就會為你記錄下來。`)
};

const ur_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی پتہ نہیں — کوڈ سے سائن اِن کریں اور یہ آپ کے لیے محفوظ ہو جائے گا۔`)
};

const fa_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز نشانی‌ای نیست — با کد وارد شوید تا برایتان ثبت شود.`)
};

const sw_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bado hakuna anwani — ingia kwa msimbo nayo itahifadhiwa kwa ajili yako.`)
};

const nl_email_row_none = /** @type {(inputs: Email_Row_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen adres — log in met een code, dan wordt het voor je vastgelegd.`)
};

/**
* | output |
* | --- |
* | "No address yet — sign in with a code and it is registered for you." |
*
* @param {Email_Row_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_row_none = /** @type {((inputs?: Email_Row_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Row_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_row_none(inputs)
	if (locale === "ja") return ja_email_row_none(inputs)
	if (locale === "zh") return zh_email_row_none(inputs)
	if (locale === "es") return es_email_row_none(inputs)
	if (locale === "pt") return pt_email_row_none(inputs)
	if (locale === "id") return id_email_row_none(inputs)
	if (locale === "fr") return fr_email_row_none(inputs)
	if (locale === "tl") return tl_email_row_none(inputs)
	if (locale === "vi") return vi_email_row_none(inputs)
	if (locale === "ko") return ko_email_row_none(inputs)
	if (locale === "de") return de_email_row_none(inputs)
	if (locale === "ru") return ru_email_row_none(inputs)
	if (locale === "tr") return tr_email_row_none(inputs)
	if (locale === "it") return it_email_row_none(inputs)
	if (locale === "pl") return pl_email_row_none(inputs)
	if (locale === "uk") return uk_email_row_none(inputs)
	if (locale === "hi") return hi_email_row_none(inputs)
	if (locale === "ar") return ar_email_row_none(inputs)
	if (locale === "ms") return ms_email_row_none(inputs)
	if (locale === "bn") return bn_email_row_none(inputs)
	if (locale === "zh-TW") return zh_tw2_email_row_none(inputs)
	if (locale === "zh-HK") return zh_hk2_email_row_none(inputs)
	if (locale === "ur") return ur_email_row_none(inputs)
	if (locale === "fa") return fa_email_row_none(inputs)
	if (locale === "sw") return sw_email_row_none(inputs)
	if (locale === "nl") return nl_email_row_none(inputs)
	return en_email_row_none(inputs)
});